// deps-lint-skip: empty, form
import '../../style/index.less';
import './index.less';
